import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import { Pricing, FAQ, FinalCTA } from "@/components/marketing/WebsiteSections";
import { SEO } from "@/lib/seo";
import { PLANS, SIGNUP_REASSURANCE } from "@/data/marketing";
export default function PricingPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Fieldlink NZ",
    description: "New Zealand-made timesheet and job management software for civil construction.",
    brand: {
      "@type": "Brand",
      name: "Fieldlink NZ"
    },
    offers: PLANS.map(p => ({
      "@type": "Offer",
      name: `Fieldlink ${p.name}`,
      price: p.price,
      priceCurrency: "NZD",
      url: "https://www.fieldlink.co.nz/register",
      availability: "https://schema.org/InStock",
      priceSpecification: {
        "@type": "UnitPriceSpecification",
        price: p.price,
        priceCurrency: "NZD",
        unitText: "MONTH"
      }
    }))
  };
  return <div className="web-site"><SEO title="Pricing — Fieldlink NZ | Timesheet & Job Management Software from NZ$39.99/month" description="Simple flat NZ pricing for Fieldlink — the NZ-made timesheet & job management app for civil construction. Plans from NZ$39.99/month for whole crews up to 12. 7-day free trial." path="/pricing" jsonLd={jsonLd} /><a className="web-skip" href="#main-content">Skip to content</a><MarketingHeader /><main id="main-content"><section className="web-hero web-wrap"><p className="web-eyebrow">Pricing in New Zealand dollars</p><h1>Simple pricing.<br /><em>Room for your crew.</em></h1><p className="web-lead">One monthly price for your crew size. 7 days free, no credit card required. No setup fee. Cancel anytime.</p><p className="web-signup-note">{SIGNUP_REASSURANCE}</p></section><Pricing heading={false} /><FAQ /><FinalCTA /></main><MarketingFooter /></div>;
}
